import React from "react";
import CreatePurchases from "./CreatePurchases";
import CreatePurchasesMobile from "./CreatePurchasesMobile";

const PagePurchase = () => {
  return (
    <>
      <CreatePurchases />
    </>
  );
};
export default PagePurchase;
